import { Button, Grid, Stack, Typography } from "@mui/material";
import SubCard from "ui-component/cards/SubCard";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import { formatDate } from "utils/DateFormater";
import { useState } from "react";
import MappedUserDialog from "./MappedUserDialog";
import StatusDialog from "./StatusDialog";
import StatusUpdateDialog from "./DeactivateDialog";
import { DeactivateFos } from "API/fos_ist/api";


const FosListTable = (props) => {
    const [OpenMappedAgents, setOpenMappedAgents] = useState(false);
    const [FosId, setFosId] = useState(null)
    const [OpenStatusDialog, setOpenStatusDialog] = useState({ open: false, data: null });
    const [OpenDeactivateDialog, setOpenDeactivateDialog] = useState({ open: false, data: null });



    const handleDeactivateOpen = (data) => {
        setOpenDeactivateDialog({ open: true, data: data });
    }

    const handleDeactivateClose = () => {
        setOpenDeactivateDialog({ open: false, data: null });
    }

    const handleOpenStatusDialog = (data) => {
        setOpenStatusDialog({ open: true, data: data });
    }

    const handleCloseStatusDialog = () => {
        setOpenStatusDialog({ open: false, data: null })
    }


    const handleOpenMappedAgents = (fosId) => {
        console.log("fosId", fosId);

        setFosId(fosId);
        setOpenMappedAgents(true);
        // GetCspForFos(1, fosId, 'mapped', setData, setIsLoading, handleAlertOpen);
        // console.log("fosId", fosId);
    }

    const handleCloseMappedAgents = () => {
        setOpenMappedAgents(false);
        setFosId(null);
    }

    const handleGet = () => {
        props.handleGet();
    }

    const handleSubmitDeactivateUser = () => {
        DeactivateFos(OpenDeactivateDialog.data.fos_id, props.setIsLoading, props.handleAlertOpen, handleGet, handleDeactivateClose);
    }

    return (
        <SubCard sx={{ mt: 1 }}>
            <MappedUserDialog open={OpenMappedAgents} fos={FosId} handleClose={handleCloseMappedAgents} />
            <StatusDialog open={OpenStatusDialog.open} data={OpenStatusDialog.data} handleClose={handleCloseStatusDialog} />
            <StatusUpdateDialog isLoading={props.IsLoading} open={OpenDeactivateDialog.open} data={OpenDeactivateDialog.data} handleClose={handleDeactivateClose} handleSubmit={handleSubmitDeactivateUser} />
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600}>FOS List</Typography>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#F8FAFC" }}>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>FOS Name</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>FOS Code</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>No of Csp Mapped</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>District</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>State</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>Activation Date</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>Mobile</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>Status</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375" }}>View CSP</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 700, color: "#592375", visibility: sessionStorage.getItem('UserType') === 'ops' || sessionStorage.getItem('UserType') === 'ds' ? 'visible' : 'hidden' }}>Action</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    props.data && props.data.data && Array.isArray(props.data.data) && props.data.data.length > 0 ?
                                        props.data && props.data.data && Array.isArray(props.data.data) && props.data.data.map((row, index) => (
                                            <TableRow
                                                key={row._id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff' }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {row.username}
                                                </TableCell>
                                                <TableCell align="left">{row.user_code ? row.user_code : "-"}</TableCell>
                                                <TableCell align="left">{row.mapped_agent_count ? row.mapped_agent_count : "-"}</TableCell>
                                                <TableCell align="left">{row.district ? row.district : "-"}</TableCell>
                                                <TableCell align="left">{row.state ? row.state : "-"}</TableCell>
                                                <TableCell align="left">{row.activation_date ? formatDate(row.activation_date) : "-"}</TableCell>
                                                <TableCell align="left">{row.mobile_number ? row.mobile_number : "-"}</TableCell>
                                                <TableCell align="left">{row.status ? row.status === 'A' ? 'ACTIVE' : 'INACTIVE' : "-"}</TableCell>
                                                <TableCell align="left"><Button disabled={row.mapped_agent_count && row.mapped_agent_count > 0 ? false : true} variant="contained" size="small" color="secondary" sx={{
                                                    backgroundColor: "#592375",
                                                    color: "#fff",
                                                    borderRadius: "10px",
                                                    '&:hover': {
                                                        backgroundColor: "#688B3A",
                                                        color: "#fff",
                                                        borderRadius: "10px",
                                                    },
                                                }} onClick={() => handleOpenMappedAgents(row.fos_id)}>View</Button></TableCell>
                                                <TableCell align="left" sx={{ visibility: sessionStorage.getItem('UserType') === 'ops' || sessionStorage.getItem('UserType') === 'ds' ? 'visible' : 'hidden' }}>
                                                    <Button variant="contained" size="small" sx={{ borderRadius: "8px", display: 'none' }} onClick={() => handleOpenStatusDialog(row)}>Edit</Button>
                                                    <Button variant="contained" disabled={row.status && row.status === "I" ? true : false} color="warning" size="small" sx={{
                                                        backgroundColor: "#592375",
                                                        color: "#fff",
                                                        borderRadius: "10px",
                                                        '&:hover': {
                                                            backgroundColor: "#688B3A",
                                                            color: "#fff",
                                                            borderRadius: "10px",
                                                        },
                                                    }} onClick={() => handleDeactivateOpen(row)}>Deactivate</Button>
                                                </TableCell>

                                            </TableRow>


                                        ))

                                        :
                                        <TableRow>
                                            <TableCell colSpan={10}>
                                                <Stack width="100%" justifyContent="center" alignItems="center">
                                                    <Typography variant="h5">No Data</Typography>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12}>
                    <TablePagination
                        component="div"
                        count={props.data && props.data.total ? props.data.total : 0}
                        page={props.data ? props.data.page - 1 : 0}
                        onPageChange={props?.handlePageChange}
                        rowsPerPage={10}
                        rowsPerPageOptions={[10]}
                    />
                </Grid>
            </Grid>
        </SubCard>
    );
}

export default FosListTable;